"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "!flex !flex-col !gap-2 tooltip-content" };
const _hoisted_6 = { class: "text-base self-center" };
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_8 = { key: 1 };
const _hoisted_9 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "!flex !flex-col !gap-2 tooltip-content" };
const _hoisted_12 = { class: "text-base self-center" };
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("button", {
    type: "button",
    class: "button-warehouse-specific-price"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-info-circle" })
    ])
], -1);
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
const shop_1 = require("../../../common/utils/shop");
const pricingStore_1 = require("../../../stores/pricing/pricingStore");
const toastStore_1 = require("../../../stores/toast/toastStore");
const vue_router_1 = require("vue-router");
const PricingEnum_1 = require("../../../stores/pricing/PricingEnum");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomPriceCell',
    props: {
        product: null
    },
    setup(__props) {
        const props = __props;
        const tagStore = (0, tagStore_1.useTagStore)();
        const pricingStore = (0, pricingStore_1.usePricingStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const pricingInfo = (0, vue_3.reactive)({
            name: '',
            fixed: 0,
            percent: 0,
            brand: '',
            diameter: ''
        });
        const priceText = (0, vue_3.computed)(() => pricingInfo.fixed !== 0
            ? `${pricingInfo.brand} + ${pricingInfo.diameter}" -> +${(0, shop_1.formatPrice)(pricingInfo.fixed, tagStore.customerCurrencyCode || props.product.prices.currencyCode)}`
            : `${pricingInfo.brand} + ${pricingInfo.diameter}" -> +${pricingInfo.percent}%`);
        const lastFetched = (0, vue_3.ref)(null);
        const navigateToEditPricing = async (pricingId) => {
            if (pricingId) {
                try {
                    const response = await pricingStore.getPricings(router, undefined, Number(pricingId));
                    pricingStore.pricingName = response.name;
                    pricingStore.pricingStatus = response.status;
                    pricingStore.pricingTyreCategoryOption = response.pricedCategory;
                    pricingStore.pricingId = response.id;
                    pricingStore.axCategories = response.axCategories;
                    const routeName = response.type === PricingEnum_1.PricingTypeEnum.FIXED ? 'fixed_pricing' : 'percent_pricing';
                    router.push({ name: routeName });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const getPricingInfo = async (pricingId, product) => {
            const productId = product === null || product === void 0 ? void 0 : product.id;
            if (!pricingId || !productId)
                return;
            if (lastFetched.value && lastFetched.value.pricingId === pricingId && lastFetched.value.productId === productId) {
                return;
            }
            try {
                const response = await pricingStore.getPricings(router, undefined, Number(pricingId));
                pricingInfo.name = response.name;
                response.customerPricingFilters.forEach((filter) => {
                    if (product.id === productId &&
                        product.brandName === filter.brand &&
                        product.diameter === filter.diameter) {
                        if (filter.fixedPricing !== 0) {
                            pricingInfo.fixed = filter.fixedPricing;
                        }
                        else {
                            pricingInfo.percent = filter.percentPricing;
                        }
                        pricingInfo.brand = product.brandName;
                        pricingInfo.diameter = product.diameter;
                    }
                });
                lastFetched.value = { pricingId, productId };
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.customPriceColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `custom-price-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (!__props.product.priceOptions.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('custom_price', 'Custom price', 'custom_price_cell')), 1),
                            ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                    (__props.product.prices.priceCustomNetId)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "pricing-info relative top-0.5 marso-icon-info-circle tooltip text-blue",
                                                tabindex: "0",
                                                role: "button",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false",
                                                onMouseenter: _cache[1] || (_cache[1] = ($event) => (getPricingInfo(__props.product.prices.priceCustomNetId, __props.product))),
                                                onFocus: _cache[2] || (_cache[2] = ($event) => (getPricingInfo(__props.product.prices.priceCustomNetId, __props.product)))
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_information', 'Pricing information', 'custom_price_cell')), 1),
                                                    (0, vue_2.createElementVNode)("div", null, "ID: " + (0, vue_2.toDisplayString)(__props.product.prices.priceCustomNetId), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'custom_price_cell')) + ": " + (0, vue_2.toDisplayString)(pricingInfo.name), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(priceText)), 1),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: "edit-pricing btn btn-rounded btn-primary self-center mt-2 mb-2",
                                                        onClick: _cache[0] || (_cache[0] = ($event) => (navigateToEditPricing(__props.product.prices.priceCustomNetId)))
                                                    }, [
                                                        _hoisted_7,
                                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('edit', 'Edit', 'custom_price_cell')), 1)
                                                    ])
                                                ])
                                            ], 32),
                                            (0, vue_2.createTextVNode)("️ " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceCustomNet || __props.product.prices.priceRetailNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1)
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceCustomNet || __props.product.prices.priceRetailNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1))
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                    (__props.product.prices.priceCustomNetId)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "pricing-info relative top-0.5 marso-icon-info-circle tooltip text-blue",
                                                tabindex: "0",
                                                role: "button",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false",
                                                onMouseenter: _cache[4] || (_cache[4] = ($event) => (getPricingInfo(__props.product.prices.priceCustomNetId, __props.product))),
                                                onFocus: _cache[5] || (_cache[5] = ($event) => (getPricingInfo(__props.product.prices.priceCustomNetId, __props.product)))
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_information', 'Pricing information', 'custom_price_cell')), 1),
                                                    (0, vue_2.createElementVNode)("div", null, "ID: " + (0, vue_2.toDisplayString)(__props.product.prices.priceCustomNetId), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'custom_price_cell')) + ": " + (0, vue_2.toDisplayString)(pricingInfo.name), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(priceText)), 1),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: "edit-pricing btn btn-rounded btn-primary self-center mt-2 mb-2",
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (navigateToEditPricing(__props.product.prices.priceCustomNetId)))
                                                    }, [
                                                        _hoisted_13,
                                                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('edit', 'Edit', 'custom_price_cell')), 1)
                                                    ])
                                                ])
                                            ], 32),
                                            (0, vue_2.createTextVNode)("️ " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceCustomNet || __props.product.prices.priceRetailNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)), 1)
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceCustomNet || __props.product.prices.priceRetailNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)), 1))
                                ]))
                        ], 64))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("warehouse_specific_price", "Warehouse-specific price", "wholesale_price_cell")) + " ", 1),
                            _hoisted_16
                        ]))
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
